import React, { useEffect } from 'react'
import { ListFilter } from 'client/fragments/listerFragment/components/Filters/ListFilter'
import { RangeFilter } from 'client/fragments/listerFragment/components/Filters/RangeFilter'
import { CheckListFilter } from 'client/fragments/listerFragment/components/Filters/CheckListFilter'
import { focusableSelector } from 'client/common/accessability'

export function Filter({
  filter,
  active,
  onChange,
  preventClick,
  onHintClick,
  rangeFilterToText,
  buttonActiveText,
  buttonInactiveText,
  format,
  lang
}) {
  if (filter.items?.length === 0 && filter.type !== 'range') return null

  if (filter.type === 'list') {
    return (
      <ListFilter
        filter={filter}
        preventClick={preventClick}
        onChange={onChange}
        buttonActiveText={buttonActiveText}
        buttonInactiveText={buttonInactiveText}
      />
    )
  }
  if (filter.type === 'range') {
    return (
      <RangeFilter
        filter={filter}
        active={active[filter.title]}
        toText={rangeFilterToText}
        onChange={onChange}
        lang={lang}
      />
    )
  }
  return (
    <CheckListFilter
      filter={filter}
      onChange={onChange}
      onHintClick={onHintClick}
      format={format}
      lang={lang}
      buttonActiveText={buttonActiveText}
      buttonInactiveText={buttonInactiveText}
    />
  )
}

export const FiltersList = ({
  filters,
  active,
  onChange,
  closeFiltersNewListerView,
  preventClick,
  onHintClick,
  rangeFilterToText,
  buttonActiveText,
  buttonInactiveText,
  format,
  lang
}) => {
  useEffect(() => {
    const container = document.querySelector('.mxd-lister-filters-panel-new-lister-view')

    const keyDownHandler = e => {
      if (e.key === 'Escape') {
        e.preventDefault()
        closeFiltersNewListerView()
      }
    }

    container.addEventListener('keydown', keyDownHandler)
    document.querySelector(`.mxd-lister-filters-panel-new-lister-view ${focusableSelector}`).focus()
    return () => {
      container.removeEventListener('keydown', keyDownHandler)
      document.querySelector('#all_filters_button').focus()
    }
  }, [closeFiltersNewListerView])

  return (
    <ul className='flex flex-column gap-1-5 p0 m0 list-reset'>
      {filters.map(filter => (
        <Filter
          key={`${filter.type}-${filter.name}`}
          filter={filter}
          active={active}
          onChange={onChange}
          preventClick={preventClick}
          onHintClick={onHintClick}
          rangeFilterToText={rangeFilterToText}
          buttonActiveText={buttonActiveText}
          buttonInactiveText={buttonInactiveText}
          format={format}
          lang={lang}
        />
      ))}
    </ul>
  )
}
